import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '../../button/button';
import { BagTickIcon, NextIcon } from '../../icons/icons';
import AccordionPanel from '../../accordion-panel/accordion-panel';
import BesicTable from '../../table/basicTable';
import CommentSection from '../../comment-section/comment-section';
import MultiSearchSelect from '../../search-select/multi-search-select';
import Checkbox from '../../custom-checkbox/custom-checkbox';

function BookingDetailsTab({
  setSupplierTab,
  bookingInfo,
  itemsData,
  commentData,
  setTabDetails,
  columns,
  prodPackDetails,
  setProdPackDetails,
}) {
  const [t] = useTranslation('manageorders');
  const packages = bookingInfo?.packages?.length
    ? bookingInfo?.packages
    : itemsData?.packages;

  const isHazmatInvalid =
    prodPackDetails?.hazmat &&
    (!prodPackDetails?.UNCode || prodPackDetails?.UNCode.length === 0);

  return (
    <div className="supplier-booking-content">
      <div className="d-flex justify-between align-center">
        <h3>{t('manageordersscreen.bookingdetailsbtn.description')}</h3>
        {false && (
          <Button
            styles="primary"
            color="outline"
            label="Load Calculator"
            iconRight={<BagTickIcon />}
            spacing="0.208vw"
            size="medium"
          />
        )}
      </div>
      <div className="d-flex cc-and-hazmat-row pb-15">
        {false && (
          <>
            <Checkbox
              name="customClearance"
              value="Custom Clearance"
              label={t('manageordersscreen.productdetails.customclearance')}
            />
            <input
              id="hsCode"
              name="HSCode"
              type="text"
              placeholder={`${t(
                'manageordersscreen.productdetails.hscodeplaceholder'
              )}*`}
              pattern="\d{1,10}"
              required
            />
          </>
        )}
        <Checkbox
          name="hazmat"
          value="HAZMAT"
          label={t('manageordersscreen.productdetails.hazmat')}
          onChange={(e) => {
            setProdPackDetails((prev) => ({
              ...prev,
              hazmat: e?.target?.checked,
              // UNCode: e?.target?.checked ? prev.UNCode : [],
            }));
          }}
          checked={prodPackDetails?.hazmat}
        />

        {prodPackDetails?.hazmat && (
          <MultiSearchSelect
            classNames="auto"
            enableLabel
            id="unCode"
            name="UNCode"
            placeholder={t(
              'manageordersscreen.productdetails.uncodeplaceholder'
            )}
            searchPlaceholder={t(
              'manageordersscreen.productdetails.AddNewUNCode'
            )}
            containerClassName="mb-0 w-200-px hazmat"
            showFooterMessage={false}
            value={prodPackDetails?.UNCode || []}
            onChange={({ target: { value } }) => {
              setProdPackDetails((prev) => ({
                ...prev,
                UNCode: value,
              }));
            }}
            enableRemove
          />
        )}
      </div>
      {packages?.length && (
        <AccordionPanel
          title={t('manageordersscreen.bookingdetailsbtn.addpackage')}
          isBordared
        >
          <BesicTable
            columns={columns}
            // bookingdetails.packages
            data={packages}
            className="supplier-booking auto-column-width"
          />
        </AccordionPanel>
      )}
      {commentData?.current?.comment && (
        <AccordionPanel
          title={t('manageordersscreen.bookingdetailsbtn.packagenotes')}
        >
          <CommentSection commentData={commentData?.current} />
        </AccordionPanel>
      )}

      <div className="supplier-booking-button-area">
        <Button
          label={t('manageordersscreen.bookingdetailsbtn.next')}
          styles="submit"
          size="large"
          className="px-24"
          onClick={() => {
            setTabDetails((prev) => {
              const updatedTabDetails = { ...prev };
              updatedTabDetails.bookingDetails = true;
              return updatedTabDetails;
            });
            setSupplierTab('shipment details');
          }}
          iconRight={<NextIcon />}
          spacing="0.694vw"
          disabled={isHazmatInvalid}
        />
      </div>
    </div>
  );
}

export default React.memo(BookingDetailsTab);
BookingDetailsTab.propTypes = {
  setSupplierTab: PropTypes.func,
  bookingInfo: PropTypes.instanceOf(Object),
  itemsData: PropTypes.instanceOf(Object),
  commentData: PropTypes.instanceOf(Object),
  setTabDetails: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  prodPackDetails: PropTypes.instanceOf(Object),
  setProdPackDetails: PropTypes.func,
};
BookingDetailsTab.defaultProps = {
  setSupplierTab: () => {},
  bookingInfo: {},
  itemsData: {},
  commentData: {},
  setTabDetails: () => {},
  prodPackDetails: {},
  setProdPackDetails: () => {},
};
